import {CreateRecommendationRequest, IRecommendationShort, Recommendation} from "../models/recommendation";
import {fetchData} from "../../Utils/fetchData";
import authToken from "../../Utils/authToken";
import {RECOMMENDATION_ENDPOINTS} from "./endpoints";
import {ApiResponse} from "../../types/api.types";
import {RecommendationComment} from "../models/recommendation_comment";


export const RecommendationsApi = {

    updateRecommendation: async (id: string, data: Partial<CreateRecommendationRequest> & {
        file?: File | null
    }): Promise<ApiResponse<Recommendation>> => {
        const formData = new FormData();
        if (data.sector) formData.append("sector", data.sector);
        if (data.name) formData.append("name", data.name);
        if (data.text) formData.append("text", data.text);
        if (data.in_charge) formData.append("in_charge", data.in_charge);
        if (data.deadline) formData.append("deadline", data.deadline);
        if (data.goal) formData.append("goal", data.goal);
        if (data.status) formData.append("status", data.status);
        if (data.file) {
            formData.append('file', data.file);
        }
        const response = await fetchData(`${RECOMMENDATION_ENDPOINTS.UPDATE}/${id}`, {
            method: "PATCH",
            headers: {
                Authorization: authToken(),
            },
            body: formData,
        }, 2);
        return response.json();
    },
    fetchRecommendationsShort: async (): Promise<ApiResponse<IRecommendationShort[]>> => {
        const response = await fetchData(RECOMMENDATION_ENDPOINTS.FETCH_SHORT, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },
    fetchRecommendationsBySector: async (sectorID: string): Promise<ApiResponse<Recommendation[]>> => {
        const response = await fetchData(`${RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR}?sectorID=${sectorID}`, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },
    deleteRecommendation: async (id: string): Promise<ApiResponse<Recommendation>> => {
        const response = await fetchData(`${RECOMMENDATION_ENDPOINTS.DELETE}/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },
    fetchRecommendation: async (recommendationId: string): Promise<ApiResponse<Recommendation>> => {
        const response = await fetchData(`${RECOMMENDATION_ENDPOINTS.GET}/${recommendationId}`, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },
    createRecommendationComment: async (data: Partial<RecommendationComment>): Promise<ApiResponse<Recommendation>> => {
        const response = await fetchData(RECOMMENDATION_ENDPOINTS.ADD_COMMENT, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: authToken(),
            },
            body: JSON.stringify(data),
        }, 2);
        return response.json();
    },
    createRecommendation: async (data: CreateRecommendationRequest): Promise<ApiResponse<Recommendation>> => {
        const formData = new FormData();
        formData.append("sector", data.sector);
        formData.append("name", data.name);
        formData.append("text", data.text);
        formData.append("in_charge", data.in_charge);
        formData.append("deadline", data.deadline);
        formData.append("goal", data.goal);
        formData.append("status", data.status);
        if (data.file) {
            formData.append('file', data.file);
        }
        const response = await fetchData(RECOMMENDATION_ENDPOINTS.CREATE, {
            method: "POST",
            headers: {
                Authorization: authToken(),
            },
            body: formData,
        }, 2);
        return response.json();
    },
    changeRecommendationStatus: async (id: string, statusNum: number): Promise<ApiResponse<Recommendation>> => {
        const response = await fetchData(RECOMMENDATION_ENDPOINTS.CHANGE_STATUS, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: authToken(),
            },
            body: JSON.stringify({
                id,
                statusNum
            }),
        }, 2);
        return response.json();
    },
    setReadRecommendationAndComments: async (id: string,): Promise<ApiResponse<Recommendation>> => {
        const response = await fetchData(RECOMMENDATION_ENDPOINTS.SET_READ, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: authToken(),
            },
            body: JSON.stringify({
                id,
            }),
        }, 2);
        return response.json();
    },
    fetchUnreadRecommendations: async (): Promise<ApiResponse<number>> => {
        const response = await fetchData(RECOMMENDATION_ENDPOINTS.GET_UNREAD_RECOMMS, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    },
}

